// extracted by mini-css-extract-plugin
module.exports = {"container":"SYvcd","empty":"_1tF9L","highQualityFrame":"_2TCWk","lowQualityFrame":"_2ubaF","thumbText":"_2og4G"};